module.exports = __webpack_public_path__ + "static/img/ZA.9e0e1363.jpg";